// // hooks/useStudentScoring.js
{/* // Added By @jaseem. */}
export const useStudentScoring = (navigate) => {

  const openScoringFromList = (student, type, reportType) => {
    if (!student?.id) return;

    navigate(`/students/${student.id}`, {
      state: {
        student,
        openScoring: type,   //  trigger key
        reportName : reportType 
      },
    });
  };

  return { openScoringFromList };
};
